<div class="container-fluid mt-4">
  <div class="mb-3">
    <button
      class="btn btn-secondary"
      [routerLink]="['/admin/ai-configuration-test']"
    >
      Konfiguration testen<i class="bi bi-arrow-right ms-2"></i>
    </button>
  </div>
  <div class="card">
    <div class="card-body">
      <div *ngIf="isLoading()" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Laden...</span>
        </div>
      </div>

      <div *ngIf="errorMessage()" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ errorMessage() }}
        <button type="button" class="btn-close" (click)="errorMessage.set('')"></button>
      </div>

      <div *ngIf="successMessage()" class="alert alert-success alert-dismissible fade show" role="alert">
        {{ successMessage() }}
        <button type="button" class="btn-close" (click)="successMessage.set('')"></button>
      </div>

      <form [formGroup]="configForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading()">
        <div class="mb-3">
          <mat-form-field>
            <mat-label>Sprachmodell</mat-label>
            <mat-select id="model_name" formControlName="model_name">
              @for (config of configs(); track config.id) {
                <mat-option [value]="config.model_name">{{ config.model_name }}</mat-option>
              }
            </mat-select>
            <mat-hint>Der Name des Sprachmodells</mat-hint>
          </mat-form-field>
        </div>

        <!-- calculation of average estimated costs per request -->
        <!--<div class="cost-hint mt-3 mb-4" role="note" aria-live="polite">
          <i class="bi bi-info-circle icon" aria-hidden="true"></i>
          <div>
            <div class="hint-title">Kosten (Hinweis)</div>
            <p class="hint-text mb-0">
              Ca. {{ average_tokens_per_request() }} Tokens / Anfrage — ungefähr
              {{ average_cost_per_request() | currency: '$' : 'symbol' : '1.4-6' }} pro Anfrage.
              Werte sind Schätzungen und dienen nur zur Orientierung.
            </p>
          </div>
        </div>-->


        <div class="mb-3">
          <mat-form-field class="w-100">
            <mat-label>System-Prompt</mat-label>
            <textarea
              matNativeControl
              class="form-control"
              id="system_prompt"
              formControlName="system_prompt"
              rows="15"
              placeholder="Geben Sie den System-Prompt ein..."
            ></textarea>
            <div class="form-text">Anweisungen für das KI-Modell</div>
          </mat-form-field>
        </div>


        <div class="row">
          <div class="col-md-6 mb-1">
            <mat-form-field class="w-100">
              <mat-label>Temperature (0-2)</mat-label>
              <input
                matInput
                type="number"
                class="form-control"
                id="temperature"
                formControlName="temperature"
                step="0.1"
                min="0"
                max="2"
              >
            </mat-form-field>
            <div class="form-text">Kreativität der Antworten (Standard: 0.7)</div>
          </div>

          <div class="col-md-6 mb-3">
            <mat-form-field class="w-100">
              <mat-label>Max. Tokens</mat-label>
              <input
                matInput
                type="number"
                class="form-control"
                id="max_tokens"
                formControlName="max_tokens"
                min="1"
              >
            </mat-form-field>
            <div class="form-text">Maximale Länge des generierten Texts. Ein Token entspricht etwa 2-4 Zeichen.</div>
          </div>
        </div>

        <div class="d-flex gap-2">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="configForm.invalid || isSaving()"
          >
            <span *ngIf="isSaving()" class="spinner-border spinner-border-sm me-2"></span>
            Speichern
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="resetForm()"
            [disabled]="isSaving()"
          >
            Zurücksetzen
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
